module.exports = "<p>\n  general-settings works!\n</p>\n"